import { Field } from 'formik';
import styled from 'styled-components';
import { inputStyles } from '../../base/forms/input';
import theme from "../../../constants/theme";

export const Wrapper = styled.div``;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-top: 1.5rem;
`;

export const StyledErrorMessage = styled.div`
	margin: 0.5rem;
	font-size: 1.4rem;
	color: ${theme.colors.primaryDark};
`;

export const InstructionsWrapper = styled.div`
	margin: 2rem 0;
	input {
		margin-top: 1rem;
	}
`;

export const StyledTextArea = styled(Field)`
	${inputStyles}
	margin-top: 2rem;
	height: 10rem;
	padding: 1rem 2.5rem 0rem 2.5rem;
`;

export const RadioWrapper = styled.div`
	margin-top: 5rem;
	background-color: ${theme.colors.secondaryLight};
	padding: 1rem;
	color: ${theme.colors.white};
`;

export const InfoText = styled.div`
	margin: -3rem 0 3rem 0;
	padding: 1rem;
	color: ${theme.colors.primary};
	font-weight: 700;
`;